<template>
    <div class="view-details">
        <b-link
            :disabled="disableBtnDueDiff"
            class="px-4 btn view-details-button view-details-link"
            :class="{'view-details-link-disabled' : disableBtnDueDiff}"
            :to="{name: 'sensors', params: {id: currentDamSelectedId || $route.params.id}, query: {tab: 'controller'} }"
        >
            {{ $t('dashboard.see-more') }}
        </b-link>
        <b-link
            :disabled="disableBtnDueDiff"
            class="px-4 btn view-details-button view-details-link"
            :class="{'view-details-link-disabled' : disableBtnDueDiff}"
            :to="{name: 'profile', params: {id: currentDamSelectedId || $route.params.id}}"
        >
            {{ $t('dashboard.profile') }}
        </b-link>
        <!--Spinner while data is ready-->
        <div class="view-disabled">
            <div class="spinner"></div>
            {{ $t('dashboard.spin') }}
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    /**
     * Bottom part of the right panel.
     * Serves as a link.
     */

    export default {
        name: "RightPanelDetails",
        computed: {
            ...mapGetters(['currentDamSelectedId', 'getDamIdFromData']),
            disableBtnDueDiff() {
                return (this.currentDamSelectedId !== this.getDamIdFromData);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/viewDetailsBtn";
</style>
